import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcViewColumn = ({ size, color }) => {
  return (
    <Icon
      className="ic-view-column material-icons tw-block tw-flex tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      view_column
    </Icon>
  )
}

IcViewColumn.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
}

export default IcViewColumn
